import { track } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'

/**
 * This component observes the selection and calls the onSelectionChange callback on the colors panel when the selection changes.
 * This gives a finer control over how the colors panel should behave when
 * selection changes and, for example, a style prop is not being used as the
 * source of the color.
 */
export const SelectionObserver = track(
  observer(() => {
    const { designStore } = useRootStore()
    const panel = designStore?.panel
    const editor = useEditor()
    const selectedShapeId = editor.getOnlySelectedShape()?.id

    useEffect(() => {
      if (panel?.type !== 'colors') return
      panel.onSelectionChange?.(editor)
    }, [selectedShapeId, panel]) // eslint-disable-line react-hooks/exhaustive-deps

    return null
  }),
)
